module.exports = "<header>\n\t<h1>\n\t\t<span class=\"name\">{{siteName}}</span>\n\t\t<span class=\"description\">{{siteDescribe}}</span>\n\t</h1>\n\t<div id=\"portrait\"></div>\n</header>\n\n<navigation-festy *ngIf=\"navigationMenu=='festy'\"></navigation-festy>\n<navigation-gourmands *ngIf=\"navigationMenu=='gourmands'\"></navigation-gourmands>\n\n<router-outlet></router-outlet>\n<photo-viewer></photo-viewer>\n<footer></footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 578
// module chunks = 1